// extracted by mini-css-extract-plugin
export default {"dashbordContainer":"SettlementPS_dashbordContainer__ZZePw"};